import Link from "next/link"
import { ILinkInfo } from '@/lib/types/common-types';

export default function DataLink({ link }: { link: ILinkInfo | undefined }) {

  return (
    <span className="data-link">
      {' '}
      {/** Render anchor link */}
      {link && link?.type === 'a' ? (
        <a
          className="text-theme-blue"
          // rel="noreferrer"
          href={link.to}
          // target="_blank"
        >
          {link.text}
        </a>
      ) : null}
      {/** Render react router link */}
      {link && link?.type === 'link' ? (
        <Link className="text-theme-blue" href={link?.to}>
          {link.text}
        </Link>
      ) : null}
    </span>
  );
}
